import { render, staticRenderFns } from "./ShowPin.vue?vue&type=template&id=a28c205e&scoped=true&"
import script from "./ShowPin.vue?vue&type=script&lang=js&"
export * from "./ShowPin.vue?vue&type=script&lang=js&"
import style0 from "./ShowPin.vue?vue&type=style&index=0&id=a28c205e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28c205e",
  null
  
)

export default component.exports